
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fitness-force-empty-report',
  templateUrl: './empty-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule]
})
export class EmptyReportComponent implements OnInit {
  private translate = inject(TranslateService);


  ngOnInit(): void {
  }

}